var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.511,
    height: 78.511,
    viewBox: "0 0 78.511 78.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11122",
    "data-name": "Path 11122",
    d: "M87.358,42.143a2.152,2.152,0,0,0,2.153-2.153V31.378a2.152,2.152,0,0,0-2.153-2.153H74.836L76.58,14.4A2.152,2.152,0,0,0,74.439,12H65.827a2.157,2.157,0,0,0-2.14,1.9l-1.8,15.322H44.693L46.437,14.4A2.152,2.152,0,0,0,44.3,12H35.684a2.157,2.157,0,0,0-2.14,1.9l-1.8,15.322H14.153A2.152,2.152,0,0,0,12,31.378V39.99a2.152,2.152,0,0,0,2.153,2.153H30.221L28.194,59.368H14.153A2.152,2.152,0,0,0,12,61.521v8.612a2.152,2.152,0,0,0,2.153,2.153H26.675L24.931,87.105a2.155,2.155,0,0,0,2.141,2.405h8.612a2.155,2.155,0,0,0,2.14-1.9l1.8-15.324H56.818L55.074,87.105a2.155,2.155,0,0,0,2.141,2.405h8.612a2.155,2.155,0,0,0,2.14-1.9l1.8-15.324H87.358a2.152,2.152,0,0,0,2.153-2.153V61.521a2.152,2.152,0,0,0-2.153-2.153H71.29l2.026-17.225Zm-44.185,0H60.364L58.337,59.368H41.147Z",
    transform: "translate(-11.5 -11.5)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.c6ad777dff5c1b35a7212ce7f3953038.svg";
export { ForwardRef as ReactComponent };